import React from "react";
import PenaltySelector from "./PenaltyReasonSelector";
import "./InputTable.css";
import { Button } from "react-bootstrap";

const ClipEndPenaltyInfoUpdate = (props) => {
  const {
    penaltyReason,
    setPenaltyReason,
    clipSelected,
    setClip,
    realMarkerY,
    realMarkerX,
    onCancelClipButtonClick,
  } = props;
  const handleOptionChange = async (event) => {
    await setPenaltyReason(parseInt(event.target.value));
  };

  let penalty =
    penaltyReason !== null ? penaltyReason : clipSelected.penaltyReasonResult;

  let markerX = realMarkerX ? realMarkerX : clipSelected.positionX;
  let markerY = realMarkerY ? realMarkerY : clipSelected.positionY;

  return (
    <>
      <div
        className="d-flex flex-fill justify-content-end align-items-end"
        style={{ marginTop: "-1.5em" }}
      >
        <Button
          className="ml-1"
          variant="outline-primary"
          size="md"
          disabled={penalty !== null ? false : true}
          onClick={async (e) => {
            await setClip(
              clipSelected.id,
              markerX,
              markerY,
              clipSelected.type,
              clipSelected.teamId,
              clipSelected.teamId,
              null,
              null,
              null,
              null,
              penalty
            );
            await setPenaltyReason(null);
          }}
        >
          Confirm Update Penalty
        </Button>
        <Button
          className="ml-1"
          variant="outline-danger"
          size="md"
          onClick={async (e) => {
            await onCancelClipButtonClick();
            await setPenaltyReason(null);
          }}
        >
          Cancel
        </Button>
      </div>
      <PenaltySelector
        penalty={penalty}
        handleOptionChange={handleOptionChange}
      />
    </>
  );
};

export default ClipEndPenaltyInfoUpdate;
